import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
// import icon from "../images/icon.png";
import icon from "../images/icon.jpeg";
import bgImg from "../images/link-img.png";
const LinkMessage = ({ text, link, metadata }) => {
  const [ogTitle, setOgTitle] = useState("");
  const [description, setDescription] = useState("");
  const [ogUrl, setOgUrl] = useState("");

  useEffect(() => {
    if (metadata) {
      setOgTitle(metadata["og:title"] || "");
      setDescription(metadata["description"] || "");
      setOgUrl(metadata["og:url"] || "");
    }
  }, [metadata]);

  const handleClick = () => {
    window.open(link, "_blank");
  };
  return (
    <StyledSystemMessage role="button" onClick={handleClick}>
      <AvatarWrapper>
        <img alt="avatar" src={icon} />
      </AvatarWrapper>
      <MessageWrapper>
        <LinkImage src={bgImg} alt="" />
        <Message>
          <h5>{description}</h5>
          <a href={link} target="1">
            {ogUrl}
          </a>
        </Message>
      </MessageWrapper>
    </StyledSystemMessage>
  );
};

const StyledSystemMessage = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;
`;

const AvatarWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  transform: translateY(-6px);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const LinkImage = styled.img`
  width: 308px;
  height: 161px;
  object-fit: cover;
`;

const Message = styled.div`
  background: #f5f5f5;
  border-radius: 0px 0px 24px 4px;
  padding: 10px 15px;
  width: 308px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  a {
    font-size: 14px;
    color: rgba(17, 17, 17, 1);
    max-width: 286px;
    line-height: 18px;
    text-decoration: none;
    font-size: 10px;
    color: rgb(117, 117, 117);
  }
`;

export default LinkMessage;
